import React from 'react';

import Grid from '@mui/material/Grid2';

import { 
  ModelBase, 
  PlayerObject,
} from "@models";
import { DATA_TYPE_INFO } from "@dndModels/Constants";

import ObjectIndex from "@components/Navigation/ObjectIndex";

interface Props { 
  extra_filter?: (obj: ModelBase | PlayerObject) => boolean;
  name_display?: (obj: ModelBase | PlayerObject) => React.ReactNode;
  disabled?: boolean;
  constants?: any;
  show_image?: boolean;
  save_all?: boolean;
  log_it?: boolean;
}

export default function SFIndex({
  extra_filter,
  name_display,
  constants = {},
  show_image = false,
  save_all = false,
  log_it = false,
}: Props) {
  const dt_info = DATA_TYPE_INFO.find(o => o.data_type === "standard_features");

  if (!dt_info) {
    return <>Invalid Data Type</>;
  } else {
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 12
          }}>
          <ObjectIndex 
            data_type="standard_features"
            name_display={name_display}
            log_it={log_it}
            save_all={save_all}
            extra_filter={extra_filter}
            show_image={show_image}
            constants={constants}
          />
        </Grid>
      </Grid>
    ); 
  } 
}
